import { StyleSheet } from 'react-native';
import { ChatComponentProps } from './type';

export const chatComponentStyles = (props: ChatComponentProps) => {
  return StyleSheet.create({
    container: {
      width: props.style?.width ?? props.width,
      height: props.style?.height ?? props.height,
      backgroundColor: 'white',
    },
    pcContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: props.style?.height ?? props.height,
    },
  });
};
